import { Navigate } from "react-router-dom";
import { LAST_READER_KEY } from "../../utils/speakerReaderConstants";

const SPEAKER_READER_PATH = /^\/deck\/[^/]+\/speaker$/;

function isStandalonePwa(): boolean {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    (window.navigator as Navigator & { standalone?: boolean }).standalone === true
  );
}

/** PWA cold start: resume last speaker reader instead of library home. */
export function SpeakerReaderResume({ children }: { children: React.ReactNode }) {
  if (!isStandalonePwa()) return <>{children}</>;

  let last: string | null = null;
  try {
    last = localStorage.getItem(LAST_READER_KEY);
  } catch {
    /* ignore */
  }

  if (last && SPEAKER_READER_PATH.test(last)) {
    return <Navigate to={last} replace />;
  }

  return <>{children}</>;
}
